import "./Home.module.css";
import TrendMitraNavigationHeader from "@/reusable_sections/Header";
import UnderstandYourAudience from "./sections/UnderstandYourAudience";
import ConsultationRoadmap from "./sections/ConsultationRoadmap";
import CuratedOrder from "./sections/CuratedOrder";
import SignatureTreatments from "./sections/SignatureTreatments";
import SupportedExchanges from "./sections/SupportedExchanges";
import TerminalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <TrendMitraNavigationHeader />
      <UnderstandYourAudience />
      <ConsultationRoadmap />
      <CuratedOrder />
      <SignatureTreatments />
      <SupportedExchanges />
      <TerminalFooter />
    </div>;
}